// Common countries list — displayed alphabetically, with "Other" always last
const COUNTRY_NAMES = [
  'Argentina',
  'Australia',
  'Austria',
  'Bahrain',
  'Belgium',
  'Brazil',
  'Canada',
  'Chile',
  'China',
  'Colombia',
  'Denmark',
  'Egypt',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hong Kong',
  'India',
  'Indonesia',
  'Ireland',
  'Italy',
  'Japan',
  'Kenya',
  'Kuwait',
  'Malaysia',
  'Mexico',
  'Netherlands',
  'New Zealand',
  'Nigeria',
  'Norway',
  'Oman',
  'Peru',
  'Philippines',
  'Poland',
  'Portugal',
  'Qatar',
  'Saudi Arabia',
  'Singapore',
  'South Africa',
  'South Korea',
  'Spain',
  'Sweden',
  'Switzerland',
  'Taiwan',
  'Thailand',
  'United Arab Emirates',
  'United Kingdom',
  'United States',
  'Venezuela',
  'Vietnam',
];

export const COUNTRIES = [
  ...COUNTRY_NAMES.sort((a, b) => a.localeCompare(b)),
  'Other',
];

export type PhoneDialOption = {
  country: string;
  iso: string;
  dial: string;
};

export const PHONE_DIAL_CODES: PhoneDialOption[] = [
  { country: 'Argentina', iso: 'AR', dial: '+54' },
  { country: 'Australia', iso: 'AU', dial: '+61' },
  { country: 'Austria', iso: 'AT', dial: '+43' },
  { country: 'Bahrain', iso: 'BH', dial: '+973' },
  { country: 'Belgium', iso: 'BE', dial: '+32' },
  { country: 'Brazil', iso: 'BR', dial: '+55' },
  { country: 'Canada', iso: 'CA', dial: '+1' },
  { country: 'Chile', iso: 'CL', dial: '+56' },
  { country: 'China', iso: 'CN', dial: '+86' },
  { country: 'Colombia', iso: 'CO', dial: '+57' },
  { country: 'Denmark', iso: 'DK', dial: '+45' },
  { country: 'Egypt', iso: 'EG', dial: '+20' },
  { country: 'Finland', iso: 'FI', dial: '+358' },
  { country: 'France', iso: 'FR', dial: '+33' },
  { country: 'Germany', iso: 'DE', dial: '+49' },
  { country: 'Greece', iso: 'GR', dial: '+30' },
  { country: 'Hong Kong', iso: 'HK', dial: '+852' },
  { country: 'India', iso: 'IN', dial: '+91' },
  { country: 'Indonesia', iso: 'ID', dial: '+62' },
  { country: 'Ireland', iso: 'IE', dial: '+353' },
  { country: 'Italy', iso: 'IT', dial: '+39' },
  { country: 'Japan', iso: 'JP', dial: '+81' },
  { country: 'Kenya', iso: 'KE', dial: '+254' },
  { country: 'Kuwait', iso: 'KW', dial: '+965' },
  { country: 'Malaysia', iso: 'MY', dial: '+60' },
  { country: 'Mexico', iso: 'MX', dial: '+52' },
  { country: 'Netherlands', iso: 'NL', dial: '+31' },
  { country: 'New Zealand', iso: 'NZ', dial: '+64' },
  { country: 'Nigeria', iso: 'NG', dial: '+234' },
  { country: 'Norway', iso: 'NO', dial: '+47' },
  { country: 'Oman', iso: 'OM', dial: '+968' },
  { country: 'Peru', iso: 'PE', dial: '+51' },
  { country: 'Philippines', iso: 'PH', dial: '+63' },
  { country: 'Poland', iso: 'PL', dial: '+48' },
  { country: 'Portugal', iso: 'PT', dial: '+351' },
  { country: 'Qatar', iso: 'QA', dial: '+974' },
  { country: 'Saudi Arabia', iso: 'SA', dial: '+966' },
  { country: 'Singapore', iso: 'SG', dial: '+65' },
  { country: 'South Africa', iso: 'ZA', dial: '+27' },
  { country: 'South Korea', iso: 'KR', dial: '+82' },
  { country: 'Spain', iso: 'ES', dial: '+34' },
  { country: 'Sweden', iso: 'SE', dial: '+46' },
  { country: 'Switzerland', iso: 'CH', dial: '+41' },
  { country: 'Taiwan', iso: 'TW', dial: '+886' },
  { country: 'Thailand', iso: 'TH', dial: '+66' },
  { country: 'United Arab Emirates', iso: 'AE', dial: '+971' },
  { country: 'United Kingdom', iso: 'GB', dial: '+44' },
  { country: 'United States', iso: 'US', dial: '+1' },
  { country: 'Venezuela', iso: 'VE', dial: '+58' },
  { country: 'Vietnam', iso: 'VN', dial: '+84' },
  { country: 'Other', iso: 'OT', dial: '+' },
];

export function dialOptionForCountry(country?: string | null): PhoneDialOption {
  const match = PHONE_DIAL_CODES.find((c) => c.country === country);
  return match || PHONE_DIAL_CODES.find((c) => c.iso === 'IN') || PHONE_DIAL_CODES[0];
}

export function formatInternationalPhone(iso?: string | null, local?: string | null): string | undefined {
  const digits = String(local || '').replace(/\D/g, '').replace(/^0+/, '');
  if (!digits) return undefined;
  const opt = PHONE_DIAL_CODES.find((c) => c.iso === iso);
  const dial = opt?.dial && opt.dial !== '+' ? opt.dial : '+';
  return `${dial} ${digits}`;
}
